export default "__VITE_ASSET__DK4YeIFp__"